import { Box } from '@chakra-ui/react';

/**
 * Viewport-pinned color wash behind the authenticated AppShell.
 * Motion is compositor-only (transform).
 */
export const ShellAtmosphere = () => {
  return (
    <Box
      className='shell-atmosphere'
      data-cy='shell-atmosphere'
      aria-hidden
      position='absolute'
      inset={0}
      overflow='hidden'
      pointerEvents='none'
      zIndex={0}
    >
      <Box className='shell-atmosphere__blob shell-atmosphere__blob--indigo' />
      <Box className='shell-atmosphere__blob shell-atmosphere__blob--purple' />
      <Box className='shell-atmosphere__blob shell-atmosphere__blob--cyan' />
    </Box>
  );
};
